import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=0015aef0&scoped=true&"
import script from "./Contacts.vue?vue&type=script&lang=ts&"
export * from "./Contacts.vue?vue&type=script&lang=ts&"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=0015aef0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0015aef0",
  null
  
)

export default component.exports